import React, { FC } from 'react';
import { WrappedContainerProps } from './ContainerTypes';
import { PositionType } from './helpers';
import Container from './Container';

const WrappedContainer: FC<WrappedContainerProps> = ({
  children: childrenProp,
  itemsPerRow,
  ...other
}) => {
  const children = React.Children.map(childrenProp, (child, index) => {
    if (!React.isValidElement(child)) {
      return null;
    }

    if (
      process.env.NODE_ENV !== 'production' &&
      (child.type as FC).name !== 'Item' &&
      (child.type as FC).displayName !== 'Item'
    ) {
      console.warn(
        'Warning: Every WrappedContainer child should be an Item component',
      );
    }

    const i = index + 1; // start count on 1
    let position: PositionType;

    if (typeof itemsPerRow === 'number') {
      const order = i > itemsPerRow ? i % itemsPerRow || itemsPerRow : i;

      // @ts-ignore
      position = `${order}/${itemsPerRow}`;
    } else {
      // @ts-ignore
      position = {};

      Object.keys(itemsPerRow).forEach((bp, bpIndex) => {
        if (
          (typeof itemsPerRow[bp] === 'number' && bpIndex < 2) ||
          !itemsPerRow[bpIndex - 1] ||
          itemsPerRow[bp] !== itemsPerRow[bpIndex - 1].value
        ) {
          const order =
            i > itemsPerRow[bp] ? i % itemsPerRow[bp] || itemsPerRow[bp] : i;

          position[bp] = `${order}/${itemsPerRow[bp]}`;
        }
      });
    }

    return React.cloneElement(child, { position });
  });

  return <Container {...other}>{children}</Container>;
};

export default WrappedContainer;
